
import { Component, Vue } from "vue-property-decorator";
import SendSmsCode from "@/components/SendSmsCode/index.vue";
import { Getter } from "vuex-class";
import { handleLogout } from "@/utils/util";
import { getStoreList } from "@/api/store";
import { removeMobileNew } from "@/api/my";
import { encryptData } from "@/utils/encryptData";

@Component({
  components: { SendSmsCode },
})
export default class CloseAccount extends Vue {
  @Getter mobile!: string;
  @Getter userId!: string;
  formData = {
    mobile: "",
    smsCode: "",
  };
  isShowMsg = false;
  businessId = "";
  isMobileErr = false;
  mobileErrMsg = "请输入正确的手机号码格式";
  errShakeClass = "animate__animated animate__headShake";
  onSendSmsCodeApiRes(res: any) {
    if (res.code === "000000") {
      this.businessId = res.data.businessId;
    } else {
      this.mobileErrMsg = res.data.msg;
      this.isMobileErr = true;
    }
  }
  // 提交
  onSubmit() {
    console.log(this.formData);
    const params = {
      ...this.formData,
      mobile: encryptData(this.formData.mobile),
      userId: this.userId,
      businessId: this.businessId,
    };
    console.log("",params);

    if (!this.businessId) {
      this.$toast("请点击获取验证码");
      return;
    }

    removeMobileNew(params)
      .then((res) => {
        if (res.code === "000000") {
          this.$dialog
            .alert({
              title: "提示",
              message: "注销成功",
              confirmButtonText: "我知道了",
            })
            .then(() => {
              // this.$bridge.callHandler("logout");
              handleLogout();
            });
        } else {
          this.$dialog
            .alert({
              title: "提示",
              message: res.msg,
              confirmButtonText: "我知道了",
            })
            .then(() => {});
        }
      })
      .catch((err) => {
        this.$toast(err.data?.msg || "注销账号出错");
      });
  }

  async fetchStoreList() {
    try {
      const res = await getStoreList({
        registMobile: this.mobile,
      });
      this.isShowMsg = res.data.length === 0;
    } catch (err) {
      console.log("err", err);
    }
  }

  showDialog() {
    this.$dialog.alert({
      getContainer: ".page-full",
      className: "error-alert",
      title: "获取验证码失败",
      message: "账号名下仍有店铺绑定，\n请前往店铺绑定解绑所有店铺",
      confirmButtonText: "我知道了",
      confirmButtonColor: "#3568D8",
    });
  }

  created() {
    this.formData.mobile = this.mobile;
    this.fetchStoreList();
  }
}
